import { render, staticRenderFns } from "./addpro.vue?vue&type=template&id=cf8d5bb4&scoped=true"
import script from "./addpro.vue?vue&type=script&lang=js"
export * from "./addpro.vue?vue&type=script&lang=js"
import style0 from "./addpro.vue?vue&type=style&index=0&id=cf8d5bb4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8d5bb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf8d5bb4')) {
      api.createRecord('cf8d5bb4', component.options)
    } else {
      api.reload('cf8d5bb4', component.options)
    }
    module.hot.accept("./addpro.vue?vue&type=template&id=cf8d5bb4&scoped=true", function () {
      api.rerender('cf8d5bb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/addpro.vue"
export default component.exports